import Vue from "vue";
import Vuex from "vuex";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    absoluteLoader: true,
    loader: false,
    socio: {
      cor: '#39424E'
    },
    colorDarkOrLight: null
  },
  mutations: {
    FINISH_LOADING(state, event) {
      state.loader = false;
      state.absoluteLoader = false;
    },

    START_LOADING(state, event) {
      state.loader = true;
      state.absoluteLoader = true;
    },
    SET_SOCIO(state, payload) {
      state.socio = payload;
    },
    SET_COLOR_DARK_OR_LIGHT(state, payload) {
      state.colorDarkOrLight = payload;
    }
  },
  actions: {},
  modules: {},
});
